import { forwardRef } from 'react'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import { IImageAsset } from '@aytm/app/swidget/base/modules/images/types'
import { getSmallAssetPath } from '@aytm/lib/common/assets'
import '@aytm/app/swidget/base/questions/Ecommerce/Ecommerce/Store/ModelViewer.ts'
import { ASSETS_TYPES, assetsCollectionElement, IEcommerceVideoAsset, IFileAsset } from '../../types.ts'
import { getAssetType } from '../../utils/getAssetType.ts'
import style from './AssetThumb.module.scss'

interface IAssetThumbProps {
  asset: assetsCollectionElement
  active: boolean
  onClick: () => void
}

// One thumbnail of an asset strip — the detail page's and the assets modal's are the same.
const AssetThumb = forwardRef<HTMLButtonElement, IAssetThumbProps>(({ asset, active, onClick }, ref) => {
  const { t } = useSurveyLocale()
  const type = getAssetType(asset)

  return (
    <button
      type="button"
      ref={ref}
      className={`${style.thumb} ${active ? style.thumbActive : ''}`}
      aria-pressed={active}
      onClick={onClick}
    >
      {ASSETS_TYPES.IMAGE === type && (
        <span
          className={style.thumbImage}
          role="img"
          aria-label={(asset as IImageAsset).alt_text || t('questions', 'img', 'noAlt')}
          style={{ backgroundImage: `url('${getSmallAssetPath(asset as IImageAsset)}')` }}
        />
      )}
      {ASSETS_TYPES.VIDEO === type && (
        <span
          className={style.thumbImage}
          role="presentation"
          style={{ backgroundImage: `url('${(asset as IEcommerceVideoAsset).video.thumbnail}')` }}
        />
      )}
      {ASSETS_TYPES.MODEL === type && (
        <span className={style.thumbModel}>
          <model-viewer src={(asset as IFileAsset).file_url} camera-controls={false} interaction-prompt="none" />
          <span className={style.thumbLayer} />
        </span>
      )}
      {active && (
        <span className={style.check}>
          <i className="pi pi-check" />
        </span>
      )}
    </button>
  )
})

AssetThumb.displayName = 'AssetThumb'

export default AssetThumb
